import React from "react";
import styles from "./ClientForm.module.css";
import ClientTopNav from "./ClientTopNav";

function WelcomeScreen({ formData }) {
  // Support multiple shapes:
  // - applicant1.name
  // - applicant1.firstName
  // - applicant1.firstName + lastName
  const a1 = formData?.applicant1 || {};
  const applicant1Name =
    a1.name ||
    [a1.firstName, a1.lastName].filter(Boolean).join(" ") ||
    "there";

  return (
    <>
      {/* ✅ Top nav on purchase side */}
      <ClientTopNav />

      <div className={styles.container}>
        <div
          style={{
            maxWidth: 860,
            margin: "0 auto",
            textAlign: "center",
            padding: "28px 16px 60px",
          }}
        >
          <h2 style={{ marginBottom: 10 }}>
            🎉 Thank you, {applicant1Name}, for your enquiry!
          </h2>

          <p style={{ margin: "10px 0", color: "#555" }}>
            We’ve received your details and one of our mortgage brokers will be
            in touch with you shortly.
          </p>

          <p style={{ margin: "10px 0 18px", color: "#555" }}>
            To save time, you can book your appointment now at a time that suits
            you.
          </p>

          <a
            href="https://www.mortgagematrix.com.au/get-started"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.nextBtn}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              textDecoration: "none",
              maxWidth: 520,
              width: "100%",
              marginTop: 10,
            }}
          >
            📅 Book Your Appointment
          </a>
        </div>
      </div>
    </>
  );
}

export default WelcomeScreen;